import React from 'react'
import { IInstructionComponentInstance, IInstructionLookUpEntry } from 'src/types/report-designer'
import { IFormSchemaColumn } from 'src/generated-types/form-schema'
import { PropertiesWrapper } from './PropertiesShared.styles'
import { ColumnSectionPanel } from './ColumnSectionPanel'
import { useInstructionComponentHandlers } from './InstructionComponentProperties.action'

export interface IInstructionComponentPropertiesProps {
  instance: IInstructionComponentInstance
  onChange: (updated: IInstructionComponentInstance) => void
  columns?: IFormSchemaColumn[]
  isColumnsLoading: boolean
  onLookUpChange?: (
    updater: (prev: Record<string, IInstructionLookUpEntry>) => Record<string, IInstructionLookUpEntry>,
  ) => void
}

export const InstructionComponentProperties: React.FC<IInstructionComponentPropertiesProps> = ({
  instance,
  onChange,
  columns,
  isColumnsLoading,
  onLookUpChange,
}) => {
  const {
    dragOverColumnIndex,
    editingColumnId,
    draftColumn,
    handleAddColumn,
    handleEditColumn,
    handleSaveColumn,
    handleDeleteColumn,
    handleDraftFieldSelect,
    handleDraftWidthChange,
    handleColumnDragStart,
    handleColumnDragOver,
    handleColumnDrop,
    handleColumnDragEnd,
    handleCancelEdit,
  } = useInstructionComponentHandlers({ instance, onChange, columns, onLookUpChange })

  const selectedFieldIds = instance.columns.map(col => col.formSchemaFieldId).filter((id): id is string => id !== null)

  const availableFieldsForDraft = columns
    ? columns.filter(f => !selectedFieldIds.includes(f.identifier) || f.identifier === draftColumn?.formSchemaFieldId)
    : []

  return (
    <PropertiesWrapper>
      <ColumnSectionPanel
        columns={instance.columns}
        isColumnsLoading={isColumnsLoading}
        editingColumnId={editingColumnId}
        draftColumn={draftColumn}
        dragOverColumnIndex={dragOverColumnIndex}
        availableFieldsForDraft={availableFieldsForDraft}
        schemaColumns={columns}
        onAddColumn={handleAddColumn}
        onEditColumn={handleEditColumn}
        onSaveColumn={handleSaveColumn}
        onCancelEdit={handleCancelEdit}
        onDeleteColumn={handleDeleteColumn}
        onDraftFieldSelect={handleDraftFieldSelect}
        onDraftWidthChange={handleDraftWidthChange}
        onColumnDragStart={handleColumnDragStart}
        onColumnDragOver={handleColumnDragOver}
        onColumnDrop={handleColumnDrop}
        onColumnDragEnd={handleColumnDragEnd}
        hideWidthConfig
      />
    </PropertiesWrapper>
  )
}
